import { render, staticRenderFns } from "./PartnerFooter.vue?vue&type=template&id=06b01cbe&scoped=true&"
import script from "./PartnerFooter.vue?vue&type=script&lang=js&"
export * from "./PartnerFooter.vue?vue&type=script&lang=js&"
import style0 from "./PartnerFooter.vue?vue&type=style&index=0&id=06b01cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b01cbe",
  null
  
)

export default component.exports